import { Component, Injector } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController } from 'ionic-angular';
import { Util } from '../../app/util';
import { Storage } from '@ionic/storage';
import { Mj_Detail } from '../mj_detail/mj_detail';
import { RoundProgressModule } from 'angular-svg-round-progressbar';
import { HatComponent } from '../component/hat';
import { LancetsComponent } from '../component/lancets';
import { LineSvgComponent } from '../component/linesvg';
import { UserStarComponent } from '../component/userstar';
import { Confirm } from '../confirm/confirm';
import { Dashboard } from '../dashboard/dashboard';
import { DetailBadge } from '../detail_badge/detail_badge';
import { HrGraphCampionatiPage } from '../hr_graphcampionati/hr_graphcampionati';
import { HrListCampionatiPage } from '../hr_listcampionati/hr_listcampionati';
import { TranslateService } from '@ngx-translate/core';
import { HrSelezionaMjPage } from '../hr_selezionamj/hr_selezionamj';

/**
 * Generated class for the Dashboard page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
/*@NgModule({
  imports: [RoundProgressModule]
})*/
@Component({
  selector: 'page-hr_profiloutente',
  templateUrl: 'hr_profiloutente.html',
})
export class HrProfiloUtentePage extends Util {
  pagine: any;
  language = 'it';
  user: any;
  mjl: any;
  page: string;
  percent_hat = '20%';
  itemExpandHeight = 250;
  refresh_dashboard: boolean = false;
  statistiche: any = {};
  percent = 34;
  utente: any = {};
  pos: any = 0;
  numutenti: any = 1;
  _percentuale: any = 0;
  campionato: any;
  showDownloadTracciati: boolean = false;
  constructor(public navCtrl: NavController, public translate: TranslateService, public navParams: NavParams, injector: Injector, loading: LoadingController, hat: HatComponent, lancets: LancetsComponent, linesvg: LineSvgComponent, userstar: UserStarComponent) {
    super(injector, loading);
    this.user = this.navParams.get('user');
    this.utente = this.navParams.get('utente');
    this.pos = this.navParams.get('pos');
    this.showDownloadTracciati = this.navParams.get('showDownloadTracciati');
    this.numutenti = this.navParams.get('numutenti');
    this.campionato = this.navParams.get('campionato');
    //console.log(this.campionato);
    var frazione = 100 / (this.numutenti - 1);
    this._percentuale = 100 - ((this.pos) * frazione);
    this.refreshpage();
    this.statistiche.grafici = [];
  }
  open_profiloutente() {

  }

  open_mj(i) {


    if (i.arr_expand == false) {
      this.GetRequest('badgeMJ', i.id + '/' + this.utente.id).then(data => {
        i.badge = data['BadgeList'];
        //console.log(data);
        // i.arr_expand = true;
      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })
      this.GetRequest('statisticheMJ', i.id + '/' + this.utente.id).then(data => {
        i.statistiche = data;
        //console.log(data);
        i.arr_expand = true;
      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })

    }

    else
      i.arr_expand = false;

  }
  refreshpage() {
    this.GetRequest('microJourneyUtenteList', this.campionato + '/' + this.utente.id).then(data => {

      //this.mjl = data['MicroJourneyList']['da_iniziare'];

      this.mjl = data['MicroJourneyList'];

      for (let i = 0; i < this.mjl.length; i++) {
        this.mjl[i].arr_expand = false;
        // this.mjl[i].badge = [];
      }

      // //console.log(this.mjl);
    }).catch((e) => {
      console.error(e)
    })
  }

  open_campionato(campionato) {
    this.navCtrl.push(HrGraphCampionatiPage);
  }
  back() {
    if (this.refresh_dashboard == false)
      this.navCtrl.pop({ animate: false });
    else
      this.go_root();
  }
  open_badge(i) {


    if (i.arr_expand == false) {
      this.GetRequest('badgeMJ', i.id).then(data => {
        i.badge = data['BadgeList'];
        //console.log(data);
        i.arr_expand = true;
      }).catch((e) => {
        //this.navCtrl.push(Mj_Detail,{mj:m});
        console.error(e)
      })

    }

    else
      i.arr_expand = false;

  }
  go_root() {
    this.navCtrl.setRoot(HrListCampionatiPage);
  }
  // reset_badge(item) {
  //   //console.log(item);
  //   this.presentPopover(event, Confirm, 'Stai per azzerare questo percorso: i tuoi progressi e i badge che hai raccolto verranno cancellati e tutte le statistiche saranno azzerate, con la sola esclusione del tempo di allenamento complessivo, vuoi procedere?').then((data) => {
  //     //console.log(data);
  //     if (data == 'confirm') {
  //       this.presentPopover(event, Confirm, 'Una volta data conferma i dati del percorso "'+item.nome+'" verranno definitivamente cancellati e non sarà più possibile recuperarli in alcun modo. Sei certo di voler azzerare questo percorso?', 'danger').then((data_) => {
  //         if (data_ == 'confirm') {
  //           this.PostRequest('resetMJ', item.id, {}, true, true).then(data_x => {
  //             this.refresh_dashboard = true; 
  //             //console.log(data_x);
  //             item.arr_expand = false;
  //           }).catch((e) => {
  //             //this.navCtrl.push(Mj_Detail,{mj:m});
  //             console.error(e)
  //           })
  //         }
  //       });
  //     }
  //   });


  // }
  show_detail_badge(b) {
    this.presentPopover(event, DetailBadge, b).then((data_) => {

    });
  }

  scarica_tracciato() {

    this.GetRequest('microJourneyUtenteList', this.campionato + '/' + this.utente.id).then(data => {

      let mjl = data['MicroJourneyList'];
      const modal = this.modalCtrl.create(HrSelezionaMjPage, { 'mj': mjl }, { showBackdrop: false, enableBackdropDismiss: false, cssClass: this.etheme.theme_selected });
      modal.onDidDismiss(data => {
        console.log(data);
        if (data) {
          this.PostRequest('hr_tracciato', '', { cid: this.campionato, mjids: data.mjids, uid: this.utente.id }).then((res: any) => {
            console.log(res);
            if (res != null && res.base_64 != null) {
              const linkSource = `data:${res.type};base64,${res.base_64}`;
              const downloadLink = document.createElement("a");
              const fileName = res.nome;

              downloadLink.href = linkSource;
              // downloadLink.target = '_blank';
              downloadLink.download = fileName;
              downloadLink.click();
            }

          }).catch((err) => {
            console.error(err);
          })
        }
      });
      modal.present();

    }).catch((e) => {
      console.error(e)
    })
  }
}



// WEBPACK FOOTER //
// ./src/pages/hr_profiloutente/hr_profiloutente.ts